import { render, staticRenderFns } from "./mentor-chat.vue?vue&type=template&id=1833cfa9&lang=pug"
import script from "./mentor-chat.vue?vue&type=script&lang=js"
export * from "./mentor-chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports